if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}

// Add-on scoop combo button handler
document.addEventListener('click', function (event) {
  const comboBtn = event.target.closest('.js-add-combo-btn');
  if (!comboBtn) return;

  // STOP the event from firing multiple times across duplicate variant forms
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  // Prevent duplicate execution if already processing
  if (comboBtn.getAttribute('aria-disabled') === 'true') return;
  comboBtn.setAttribute('aria-disabled', 'true');

  const currentVariantId = comboBtn.dataset.variantId;
  const addonVariantId = comboBtn.dataset.addonId;
  const spinner = comboBtn.querySelector('.loading-overlay__spinner');

  if (spinner) spinner.classList.remove('hidden');

  const cartDrawer = document.querySelector('cart-drawer');
  const cartNotification = document.querySelector('cart-notification');
  const cartComponent = cartDrawer || cartNotification;

  const sectionsToRender = cartComponent && typeof cartComponent.getSectionsToRender === 'function'
    ? cartComponent.getSectionsToRender().map((section) => section.id)
    : ['cart-drawer', 'cart-icon-bubble'];

  const payload = {
    items: [
      { id: parseInt(currentVariantId, 10), quantity: 1 },
      { id: parseInt(addonVariantId, 10), quantity: 1 }
    ],
    sections: sectionsToRender,
    sections_url: window.location.pathname
  };

  fetch(`${routes.cart_add_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      throw new Error(response.description || 'Failed to add items to cart.');
    }

    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
    }

    if (cartComponent && typeof cartComponent.renderContents === 'function') {
      cartComponent.renderContents(response);
    }

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open(comboBtn);
    } else if (cartNotification && typeof cartNotification.open === 'function') {
      cartNotification.open();
    } else if (window.publish && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', response });
    }
  })
  .catch((error) => {
    console.error('Error adding combo to cart:', error);
  })
  .finally(() => {
    comboBtn.removeAttribute('aria-disabled');
    if (spinner) spinner.classList.add('hidden');
  });
});